import React from 'react';
import { Link } from 'react-router-dom';

import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
const Pagination = (props) => {
  const handlePagination = (current) => {
    props.pagination(current);
  };
  return (
    <>
      <div className="flex items-center justify-between border-t border-gray-200 py-3 ">
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between ">
          <div></div>
          <div>
            <nav
              className="isolate inline-flex -space-x-px rounded-md shadow-sm bg-white"
              aria-label="Pagination"
            >
              <Link
                onClick={() => handlePagination(props.current - 1)}
                className={
                  props.current === 1
                    ? 'pointer-events-none relative inline-flex items-center px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0'
                    : ' relative inline-flex items-center px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0'
                }
              >
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                <span className="sr-only">Prev</span>
              </Link>
              {props.total < 7 ? (
                <>
                  {Array.apply(0, Array(props.total)).map((arr, i) => (
                    <Link
                      key={i}
                      onClick={() => handlePagination(i + 1)}
                      className={
                        props.current === i + 1
                          ? 'relative inline-flex pointer-events-none  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20  focus:outline-offset-0 dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                          : 'relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 dark:text-gray-900 cursor-pointer'
                      }
                    >
                      {i + 1}
                    </Link>
                  ))}
                </>
              ) : props.current % 5 >= 0 &&
                props.current > 4 &&
                props.current + 2 < props.total ? (
                <>
                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    1
                  </Link>
                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.current - 1)}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.current - 1}
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.current)}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.current}
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.total + 1)}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.current + 1}
                  </Link>
                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.total)}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.total}
                  </Link>
                </>
              ) : props.current % 5 >= 0 &&
                props.current > 4 &&
                props.current + 2 >= props.total ? (
                <>
                  <Link
                    onClick={() => handlePagination(1)}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    1
                  </Link>

                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.total - 3)}
                    className={
                      props.current === props.total - 3
                        ? ' pointer-events-none relative inline-flex  items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 dark:text-black dark:bg-[#97c05b] text-black bg-[#97c05b]'
                        : 'relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 cursor-pointer'
                    }
                  >
                    {props.total - 3}
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.total - 2)}
                    className={
                      props.current === props.total - 2
                        ? ' pointer-events-none relative inline-flex  items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 dark:text-black text-black dark:bg-[#97c05b] bg-[#97c05b]'
                        : 'relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 cursor-pointer'
                    }
                  >
                    {props.total - 2}
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.total - 1)}
                    className={
                      props.current === props.total - 1
                        ? 'relative inline-flex pointer-events-none items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 dark:text-black dark:bg-[#97c05b] bg-[#97c05b] text-black'
                        : 'relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 cursor-pointer '
                    }
                  >
                    {props.total - 1}
                  </Link>
                  <Link
                    onClick={() => handlePagination(props.total)}
                    className={
                      props.current === props.total
                        ? 'relative inline-flex  pointer-events-none items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 dark:hover:bg-gray-500 focus:outline-offset-0 dark:text-black text-black dark:bg-[#97c05b] bg-[#97c05b]'
                        : 'relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20  focus:outline-offset-0 cursor-pointer  '
                    }
                  >
                    {props.total}
                  </Link>
                </>
              ) : (
                <>
                  {Array.apply(0, Array(5)).map((arr, i) => (
                    <Link
                      key={i}
                      onClick={() => handlePagination(i + 1)}
                      className={
                        props.current === i + 1
                          ? 'relative inline-flex pointer-events-none items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 dark:text-black text-black dark:bg-[#97c05b] bg-[#97c05b]'
                          : 'relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 cursor-pointer focus:outline-offset-0  '
                      }
                    >
                      {i + 1}
                    </Link>
                  ))}
                  <Link className="relative inline-flex  text-black items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={() => handlePagination(props.total)}
                    className="relative inline-flex  text-black  items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.total}
                  </Link>
                </>
              )}
              <Link
                onClick={() => handlePagination(props.current + 1)}
                className={
                  props.current === props.total
                    ? 'pointer-events-none relative inline-flex items-center px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0'
                    : ' relative inline-flex items-center px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer'
                }
              >
                <span className="sr-only">Next</span>
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagination;
